/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum TypeOfCancerIcon {
  bladder = 'Cancer-Urinary',
  brain = 'Cancer-Brain',
  breast = 'Cancer-Breast',
  cervical = 'Cancer-Cervical',
  colon = 'Cancer-Colon',
  esophageal = 'Cancer-Esophageal',
  endometrial = 'Cancer-Uterine',
  head_and_neck = 'Cancer-Oral',
  kidney = 'Cancer-Kidney',
  larynx = 'Cancer-Larynx',
  leukemia = 'Cancer-Leukemia',
  liver = 'Cancer-Liver',
  lung = 'Cancer-Lung',
  lymphoma = 'Cancer-Lymphoma',
  melanoma = 'Cancer-Melanoma',
  multiple_myeloma = 'Cancer-Myeloma',
  myeloma = 'Cancer-Myeloma',
  ovarian = 'Cancer-Ovarian',
  pancreatic = 'Cancer-Pancreas',
  prostate = 'Cancer-Prostate',
  stomach = 'Cancer-Stomach',
  testicular = 'Cancer-Testicular',
  thyroid = 'Cancer-Thyroid',
  uterine = 'Cancer-Uterine',
  overall = 'Cancer-Lymphoma',
}

export type TypeOfCancer = keyof typeof TypeOfCancerIcon;
